<template>
  <div class="training-rejoin-page">
    <TrainingWrap>
      <template #default="{batchId}">
        <div class="cont-wrap">
          <template v-if="batchId">
            <TemplateDataGrid :key="batchId"
                              ref="grid"
                              gridId="trainingRejoin"
                              v-bind="{batchId}"/>
          </template>
          <Hint v-else type="empty">请先选择批次</Hint>
        </div>
      </template>
    </TrainingWrap>
  </div>
</template>

<script>
import TrainingWrap from '../wrap'
import Hint from '../../../../../elements/Hint.vue'
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'
export default {
  name: 'TrainingRejoinPage',
  components: {
    TrainingWrap,
    Hint,
    TemplateDataGrid
  }
}
</script>

<style scoped lang="scss">
.training-rejoin-page {
  height: 100%;
  .cont-wrap {
    height: 100%;
  }
}
</style>
